import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import useConfiguration from "../../hooks/useConfiguration";
import { getInboxMessageData } from "./action";

const InboxHeader = (props) => {
  const config = useConfiguration();
  const inboxMailCount = useSelector(state => state.notificationHeader?.inboxMailCount);
  const params = useSelector((store) => store.inbox.params);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  useEffect(() => {
    props.getInboxMessagesCount(inboxMailCount);
  }, [inboxMailCount]);

  const MyInboxMessages = () => {
    if (location.pathname === "/inbox") {
      dispatch(getInboxMessageData({ url: `${config.baseUrl}/Employers/get-emailinbox-listingmessages`, params }));
      props?.hideHeaderNotification("/inbox")
    } else {
      navigate("/inbox");
    }
  };
  return (
    <>
      <div className="drop-heading border-bottom">
        <div className="d-flex">
          <h6 className="mt-1 mb-0 fs-16 fw-semibold text-dark">
            You have {inboxMailCount} new Emails
          </h6>
          <i style={{right:"1.25rem", top:"0.5rem", cursor:"pointer"}} onClick={() => props?.updateNotificationFlag(prev => ({...prev,inboxMailFlag:false}))} className="position-absolute  fa fa-remove "></i>
          {/* <div className="ms-auto">
               <a href="#"
                  className="text-muted p-0 fs-12">make all  unread</a>
           </div> */}
        </div>
      </div>

      {props?.loader && <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: '200px' }}>Loading...</div>}
      {props?.data && !props?.loader && (
        <div
          style={{ overflowY: "auto", height: "19rem" }}
          className="message-menu"
        >
          {props?.data?.map((item) => {
            return (
              <span className="dropdown-item d-flex">
                <span
                  className="text-primary"
                  style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", background: "#D3D3D3", height: "2.25rem", width: "2.25rem", borderRadius: "100%", marginRight: "0.5rem", fontSize: "1rem", fontWeight: "500" }}
                >
                  {item?.candidateName?.at(0) ?? ""}
                </span>
                <div className="wd-90p">
                  <div className="d-flex">
                    <h5 className="mb-1">{item.candidateName}</h5>
                    <small className="text-muted ms-auto text-end">
                      {item.messageDateTime}
                    </small>
                  </div>
                  <div>
                    <span style={{ width: "200px" }} className="dangerouse_render_truncate" dangerouslySetInnerHTML={{ __html: item.messageText }}></span>
                  </div>
                </div>
              </span>
            );
          })}
          {props?.data?.length === 0 && !props?.loader && <div style={{ display: "flex", alignItems: "center", justifyContent: "center", top: '130px', position: 'relative' }}>New data not found</div>}
        </div>
      )}

      <div className="dropdown-divider m-0"></div>
      {/* // eslint-disable-next-line jsx-a11y/anchor-is-valid */}
      <span
        style={{ cursor: "pointer" }}
        onClick={MyInboxMessages}
        className="dropdown-item text-center p-3 text-muted"
      >
        See all Emails
      </span>
    </>
  );
};

export default InboxHeader;
